import ru from '../langs/ru.json'
import en from '../langs/en.json'


import {
    AIR_CATEGORIES,
    AIR_CONFIG, APP_LANG,
    CATEGORY_SELECT,
    CHANGE_SEARCH,
    EXCLUSIVE_CHANGE,
    FORM_BRANDS_NAME,
    FORM_EMAIL,
    FORM_POLICY,
    FORM_SUBMIT,
    FORM_SUBSCRIBE,
    HIDE_ERROR,
    HIDE_LOADER,
    HOT_DEAL_CHANGE,
    MAIN_REQUEST,
    MOBILE_FILTER,
    MOBILE_GUIDES,
    MOBILE_MENU,
    MOBILE_TRACKING_CHANGE,
    PAGES_REQUEST,
    RESET_FILTERS,
    SEARCH_ITEMS,
    SET_APP_DATA,
    SHOW_ERROR,
    SHOW_LOADER,
    SUBSCRIBE_SET,
    TOGGLE_INFO
} from "./types";

//const APP_LANG = document.documentElement.lang;
const initialState = {
    isLoading: false,
    isError: false,
    categoriesRequest: false,
    configRequest: false,
    authRequest: false,
    dataRequest: false,
    pagesRequest: false,
    pages: null,
    current_page: null,
    search: '',
    current_category: '',
    mobile_tracking: false,
    exclusive: false,
    hot_deal: false,
    brands: [],
    categories: [],
    aircategories: [],
    airconfig: [],
    subscribe_type: 1,
    subscribed_brands: [],
    app_lang: APP_LANG,
    translate: APP_LANG === 'ru' ? ru : en,
    isMobile: window.innerWidth <= 1100 ? true : false,
    mobileMenu: false,
    showInfo: true,
    formBrandsName: '',
    formBrandsNameError: false,
    formEmail: '',
    formEmailError: false,
    formPolicy: true,
    formPolicyError: false,
    formSubscribe: true,
    formError: '',
    formSubmited: false,
    searchRequest: false,
    searchItems: [],
    mobileFilter: false,
    mobileGuides: false
}
export const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_LOADER:
            return {...state, isLoading: true}
        case HIDE_LOADER:
            return {...state, isLoading: false}
        case SHOW_ERROR:
            return {...state, isError: true}
        case HIDE_ERROR:
            return {...state, isError: false}
        case MAIN_REQUEST:
            return {...state, dataRequest: true}
        case SET_APP_DATA:
            return {
                ...state,
                brands: action.payload.brands,
                categories: action.payload.categories,
                dataRequest: true,
                isLoading: false
            }
        case PAGES_REQUEST: {
            return {
                ...state,
                pages: action.payload.pages,
                current_page: action.payload.current_page,
                current_category: action.payload.current_category,
                pagesRequest: true,
            }
        }
        case CHANGE_SEARCH:
            return {...state, search: action.payload}
        case CATEGORY_SELECT:
            return {
                ...state,
                current_category: action.payload,
                current_page: null,
                mobileFilter: false
            }
        case AIR_CATEGORIES:
            return {
                ...state,
                aircategories: action.payload.aircategories,
                current_category: action.payload.current_category,
                categoriesRequest: true
            }
        case SEARCH_ITEMS:
            return {
                ...state,
                searchItems: action.payload.searchItems,
                searchRequest: true
            }
        case MOBILE_TRACKING_CHANGE:
            return {
                ...state,
                mobile_tracking: action.payload,
                mobileFilter: false
            }
        case EXCLUSIVE_CHANGE:
            return {
                ...state,
                exclusive: action.payload,
                mobileFilter: false
            }
        case HOT_DEAL_CHANGE:
            return {
                ...state,
                hot_deal: action.payload,
                mobileFilter: false
            }
        case RESET_FILTERS:
            return {
                ...state,
                mobile_tracking: false,
                exclusive: false,
                hot_deal: false,
                search: '',
                current_category: '',
                current_page: null,
                mobileFilter: false
            }
        case AIR_CONFIG:
            return {
                ...state,
                airconfig: action.payload.airconfig,
                configRequest: true
            }
        case SUBSCRIBE_SET:
            return {
                ...state,
                subscribe_type: action.payload.subscribe_type,
                subscribed_brands: action.payload.subscribed_brands,
                authRequest: true
            }
        case MOBILE_MENU: {
            return {
                ...state,
                mobileMenu: action.payload
            }
        }
        case MOBILE_FILTER: {
            return {
                ...state,
                mobileFilter: action.payload
            }
        }
        case TOGGLE_INFO: {
            return {
                ...state,
                showInfo: action.payload
            }
        }
        case FORM_POLICY: {
            return {
                ...state,
                formPolicy: action.payload.value,
                formPolicyError: action.payload.error,
            }
        }
        case FORM_SUBSCRIBE: {
            return {
                ...state,
                formSubscribe: action.payload
            }
        }
        case FORM_BRANDS_NAME: {
            return {
                ...state,
                formBrandsName: action.payload.value,
                formBrandsNameError: action.payload.error
            }
        }
        case FORM_EMAIL: {
            return {
                ...state,
                formEmail: action.payload.value,
                formEmailError: action.payload.error
            }
        }
        case FORM_SUBMIT: {
            return {
                ...state,
                formSubmited: action.payload
            }
        }
        case MOBILE_GUIDES: {
            return {
                ...state,
                mobileGuides: action.payload
            }
        }
        default:
            return state
    }
}